// extracted by mini-css-extract-plugin
export default {"badge":"Qnxtu","text":"KztRx","appear-from-above":"haCYT","appearFromAbove":"haCYT"};